import { IAnnouncement, IAnnouncementData, IAnnouncementParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const announcementsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    //change params
    GET_announcements: builder.query<ITableRes<IAnnouncement>, IAnnouncementParams>({
      query: (params) => ({
        url: '/announcements/',
        params,
      }),
      providesTags: ['announcements'],
    }),
    GET_announcementById: builder.query<IAnnouncement, number>({
      query: (id) => ({
        url: `/announcements/${id}/`,
      }),
      providesTags: ['announcement'],
    }),
    POST_announcement: builder.mutation<IAnnouncement, IAnnouncementData>({
      query: (body) => ({
        url: `/announcements/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['announcements'],
    }),
    PATCH_announcement: builder.mutation<IAnnouncement, { id: number; body: IAnnouncementData }>({
      query: ({ id, body }) => ({
        url: `/announcements/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['announcements', 'announcement'],
    }),
    DELETE_announcement: builder.mutation<IAnnouncement, number>({
      query: (id) => ({
        url: `/announcements/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['announcements'],
    }),
  }),
})

export const {
  useGET_announcementsQuery,
  useGET_announcementByIdQuery,
  usePOST_announcementMutation,
  usePATCH_announcementMutation,
  useDELETE_announcementMutation,
} = announcementsAPI
